import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import store  from '../../store';

class CriteriaList extends Component {
  render() {
    const { criteria, auth } = this.props;

    if(!criteria) {
      return (
        <div>Loading...</div>
      );
    }

    console.log(criteria);

    let criteriaList = criteria.filter(entry => entry.createdBy === auth.uid);

    if(criteriaList.length === 0) {
      return (
        <div></div>
      );
    }
    if(criteria) {
      return (
        <div>
          <h2>Criteria</h2>
          <div className="row">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                { criteriaList.length === 0 && 
                  <tr>
                    <td colSpan="3">No criteria found</td>
                  </tr>
                }
                { criteriaList.map((entry, index) => (
                  <tr key={entry.id}>
                    <td>{entry.name}</td>
                    <td>{entry.description}</td>
                    <td style={{"textAlign": "right"}}><Link to={`/criteria/edit/${entry.id}`} className="btn btn-dark">Edit</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return (
        <div>Loading...</div>
      );
    }
  }
}

export default compose(
  firestoreConnect(props => [
    {
      collection: 'criteria',
      where: ['createdBy', '==', store.getState().firebase.auth.uid]
    }
  ]),
  connect((state) => ({
    auth: state.firebase.auth,
    criteria: state.firestore.ordered.criteria
  }))
)(CriteriaList);

/*
export default compose(
  firestoreConnect(['criteria']),
  connect((state) => ({
    auth: state.firebase.auth,
    criteria: state.firestore.ordered.criteria
  }))
)(CriteriaList);

*/